import { render, staticRenderFns } from "./car-attribute-list.vue?vue&type=template&id=170772f8&scoped=true&"
import script from "./car-attribute-list.vue?vue&type=script&lang=js&"
export * from "./car-attribute-list.vue?vue&type=script&lang=js&"
import style0 from "./car-attribute-list.vue?vue&type=style&index=0&id=170772f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170772f8",
  null
  
)

export default component.exports